<template>
  <div>
    <v-row>
      <v-col cols="12" lg="12" md="12" sm="12">
        <Analysis @rowSelected="rowSelected($event)"></Analysis>
      </v-col>

      <v-col cols="12" lg="12" md="12" sm="12">
        <AnalysisDetail :RmnID="RmnID"></AnalysisDetail>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Analysis from "@/views/TechnicalAssistance/RawMaterialAnalysis/Analysis/Analysis";
import AnalysisDetail from "@/views/TechnicalAssistance/RawMaterialAnalysis/Analysis/AnalysisDetail";

export default {
  name: "RawMaterialAnalysisView",
  components: { Analysis, AnalysisDetail },
  data() {
    return {
      RmnID: 0,
    };
  },
  methods: {
    rowSelected(rows) {
      if (rows && rows.length > 0) {
        this.RmnID = rows[0].RmnID;
      } else {
        this.RmnID = 0;
      }
    },
  },
};
</script>